import CheckCircle from "@mui/icons-material/CheckCircle";

import { makeSvgIcon } from "./svg-icon";

export const SuccessIcon = makeSvgIcon(
  CheckCircle,
  (theme) => theme.palette.success.main,
);

export default SuccessIcon;
